import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import {
  ConversationResponse,
  CreateConversationResponse,
  MessagesPageResponse,
  SendMessageRequest,
  SendMessageResponse,
} from '../model/one-on-one-chat.types';

@Injectable({ providedIn: 'root' })
export class OneOnOneChatHttpService {
  private readonly http = inject(HttpClient);

  private readonly baseUrl = `${environment.url.api}/chat`;

  createConversation(agentExternalId: string): Observable<CreateConversationResponse> {
    return this.http.post<CreateConversationResponse>(`${this.baseUrl}/conversation`, {
      agent: { externalId: agentExternalId },
    });
  }

  getConversation(conversationId: string): Observable<ConversationResponse> {
    return this.http.get<ConversationResponse>(`${this.baseUrl}/conversation/${conversationId}`);
  }

  markAsRead(conversationId: string, messageId: string): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/conversation/${conversationId}/read`, { messageId });
  }

  getMessages(conversationId: string, continuationToken?: string): Observable<MessagesPageResponse> {
    const params = continuationToken ? new HttpParams().set('continuationToken', continuationToken) : undefined;
    return this.http.get<MessagesPageResponse>(`${this.baseUrl}/conversation/${conversationId}/message`, { params });
  }

  sendMessage(conversationId: string, request: SendMessageRequest): Observable<SendMessageResponse> {
    return this.http.post<SendMessageResponse>(`${this.baseUrl}/conversation/${conversationId}/message`, request);
  }
}
